import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import c from './assets/sass/list.module.scss'

export const List = ({ onDayClick, adventStatus }) => {
    const { t } = useTranslation()
    const totalDays = adventStatus?.totalDays || 31
    const days = Array.from({ length: totalDays }, (_, i) => i + 1)

    if (!adventStatus) {
        return (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                {t('advent.list.loading')}
            </div>
        )
    }

    const { currentDay, days: dayStatuses } = adventStatus

    const available = dayStatuses.find(
        (d) => d.status === 'available' && d.canClaim
    )
    const availableDay = available?.day

    const getDayStatus = (day) => {
        const dayStatus = dayStatuses.find((d) => d.day === day)
        return dayStatus || { status: 'locked', canClaim: false }
    }

    const getContent = (day) => {
        const dayStatus = getDayStatus(day)

        if (availableDay && day === availableDay && day === currentDay) {
            return (
                <li className={cn(c.item, c.wide)} key={day}>
                    <div className={c.banner}>
                        <span className={c.bannerDay}>
                            {t('advent.list.day', { day })}
                        </span>
                        <div className={c.get}>
                            <button
                                className={c.button}
                                onClick={() => onDayClick && onDayClick(day)}
                            >
                                <span>{t('advent.list.get')}</span>
                            </button>
                        </div>
                    </div>
                </li>
            )
        }

        if (dayStatus.status === 'missed') {
            return (
                <li className={c.item} key={day}>
                    <div className={c.row}>
                        <div className={c.missed} />
                        <div className={c.missedText}>
                            <span className={c.missedDay}>{day}</span>
                            <span className={c.missedTitle}>
                                {t('advent.list.missed')}
                            </span>
                        </div>
                    </div>
                </li>
            )
        }

        if (dayStatus.status === 'claimed') {
            return (
                <li className={cn(c.item, c.got)} key={day}>
                    <div className={c.row}>
                        <div className={c.default} />
                    </div>
                </li>
            )
        }

        if (dayStatus.status === 'available' && dayStatus.canClaim) {
            return (
                <li className={cn(c.item, c.current)} key={day}>
                    <div className={c.row}>
                        <button
                            className={c.dayButton}
                            onClick={() => onDayClick && onDayClick(day)}
                            style={{
                                background: 'none',
                                border: 'none',
                                width: '100%',
                                height: '100%',
                                cursor: 'pointer',
                            }}
                        >
                            <div className={c.default} />
                            <span className={c.defaultDay}>{day}</span>
                        </button>
                    </div>
                </li>
            )
        }

        if (dayStatus.status === 'next') {
            return (
                <li className={cn(c.item, c.current)} key={day}>
                    <div className={c.row}>
                        <div className={c.default} />
                        <span className={c.defaultDay}>{day}</span>
                    </div>
                </li>
            )
        }

        return (
            <li className={c.item} key={day}>
                <div className={c.row}>
                    <div className={c.default} />
                    <span className={c.defaultDay}>{day}</span>
                </div>
            </li>
        )
    }

    return (
        <ul className={c.component}>
            {days.map((day, index) => {
                if (index === 0 && availableDay) {
                    return getContent(availableDay)
                }
                if (availableDay && day === availableDay && index !== 0) {
                    return null
                }
                return getContent(day)
            })}
        </ul>
    )
}
